/**
 * Backend `definitions.DEFINITION_NAME_PATTERN`: the runs route answers 422
 * for any other name. Backend `test_panel_name_pattern.py` pins this
 * literal to it, so the two never drift apart.
 */
export const DEFINITION_NAME_PATTERN = /^[a-z0-9][a-z0-9-]{0,62}$/;

export function isDefinitionName(name: string): boolean {
  return DEFINITION_NAME_PATTERN.test(name);
}

/** The typed name, trimmed, when it is a definition name; else null. */
export function validName(name: string): string | null {
  const trimmed = name.trim();
  return isDefinitionName(trimmed) ? trimmed : null;
}
